import React from 'react';
import { SectionDivider } from './SectionDivider';
import { BlogCard } from './BlogCard';
export function BlogTeaser() {
  const posts = [{
    title: 'Website Design Ireland — Pricing Guide 2026',
    excerpt: 'From DIY builders to expensive agencies, we break down the real costs of getting a website in Ireland.',
    slug: 'website-cost-ireland-2026',
    date: 'October 15, 2025',
    readTime: '8 min read'
  }, {
    title: 'SEO Tips for Irish Local Businesses',
    excerpt: 'Demystifying SEO for Irish SMEs. Practical tips to help your local business rank higher on Google.',
    slug: 'seo-small-businesses-ireland',
    date: 'September 20, 2025',
    readTime: '9 min read'
  }, {
    title: 'How to Get More Customers Online in Ireland',
    excerpt: 'A complete guide for business owners on choosing the right web design partner and strategy.',
    slug: 'website-design-dublin-small-businesses',
    date: 'October 10, 2025',
    readTime: '6 min read'
  }];
  return <section id="blog-teaser" className="py-16 px-4 md:px-6" style={{
    backgroundColor: '#050505'
  }} data-id="element-98">
      <div className="max-w-6xl mx-auto" data-id="element-99">
        <div className="text-center mb-12 reveal" data-id="element-100">
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-4" data-id="element-101">
            Articles &amp; Tips for Irish Business Websites
          </h2>
          <p className="text-white/60 max-w-2xl mx-auto" data-id="element-102">
            Learn more about{' '}
            <a href="/" className="text-[#c9a84c] hover:underline" onClick={e => {
            e.preventDefault();
            window.scrollTo(0, 0);
          }} data-id="element-103">
              website design Ireland
            </a>{' '}
            and how to grow your local business online.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 reveal" data-id="element-104">
          {posts.map((post, idx) => <div key={idx} style={{
          transitionDelay: `${idx * 100}ms`
        }} data-id="element-105">
              <BlogCard {...post} data-id="element-106" />
            </div>)}
        </div>
      </div>
      <SectionDivider data-id="element-107" />
    </section>;
}